import React, { FC } from 'react';
import { Navigate } from 'react-router';

import { DASHBOARD_ROOT_ROUTE } from '~constants/routes';
import { SessionState } from '~reducers/session';

interface BoRouteAuthorizationProps {
	appliedRoles: string[];
	component: React.ComponentType<unknown>;
	fallback?: string;
	sessionUserRole?: SessionState['roleName'];
}

/**
 * A wrapper that enforces role-based access control for components
 */
export const BoRouteAuthorization = ({
	appliedRoles,
	component: Component,
	fallback = DASHBOARD_ROOT_ROUTE,
	sessionUserRole,
}: BoRouteAuthorizationProps): FC => {
	const WrappedComponent = (
		props: Record<string, unknown>,
	): React.JSX.Element | null => {
		if (!sessionUserRole) {
			return null;
		}

		return appliedRoles.includes(sessionUserRole) ? (
			<Component {...props} />
		) : (
			<Navigate to={fallback} replace />
		);
	};

	return WrappedComponent;
};
